import { render, staticRenderFns } from "./PoiContactAndInfo.vue?vue&type=template&id=043e44a8&"
import script from "./PoiContactAndInfo.vue?vue&type=script&lang=js&"
export * from "./PoiContactAndInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports